<div class="confirmation" [ngClass]="{ 'align-left': alignLeft}">
  <div *ngIf="icon">
    <ng-container [ngSwitch]="iconWeight">
      <div *ngSwitchCase="IconWeight.LIGHT" class="confirmation__icon">
        <vo-icon [icon]="icon | strapiIcon" size="2xl" [color]="iconColor" iconSet="light" />
      </div>
      <div *ngSwitchCase="IconWeight.REGULAR" class="confirmation__icon">
        <vo-icon [icon]="icon | strapiIcon" size="2xl" [color]="iconColor" iconSet="regular" />
      </div>
      <div *ngSwitchCase="IconWeight.SOLID" class="confirmation__icon">
        <vo-icon [icon]="icon | strapiIcon" size="2xl" [color]="iconColor" iconSet="solid" />
      </div>
      <div *ngSwitchCase="IconWeight.DUOTONE" class="confirmation__icon">
        <vo-icon [icon]="icon | strapiIcon" size="2xl" [color]="iconColor" iconSet="duotone" />
      </div>
      <div *ngSwitchCase="IconWeight.BRANDS" class="confirmation__icon">
        <vo-icon [icon]="icon | strapiIcon" size="2xl" [color]="iconColor" iconSet="brands" />
      </div>
      <div *ngSwitchDefault class="confirmation__icon">
        <vo-icon [icon]="icon | strapiIcon" size="2xl" [color]="iconColor" iconSet="regular" />
      </div>
    </ng-container>
  </div>
  <!-- <div class="confirmation__img" *ngIf="iconSrc">
    <vm-media [source]="iconSrc | mediaSrcStrapi: strapiUrl"></vm-media>
  </div> -->

  <div class="confirmation__title" *ngIf="title">
    <h1 vo-text [size]="'T600'" [weight]="'medium'">{{ title }}</h1>
  </div>

  <div class="confirmation__title" *ngIf="subtitle">
    <h3 vo-text [size]="'T600'" [weight]="'medium'">{{ subtitle }}</h3>
  </div>

  <div class="confirmation__info" *ngIf="info">
    <div vo-text [size]="'T300'" [weight]="'regular'">
      <markdown [disableSanitizer]="true" ngPreserveWhitespaces>{{ info }}</markdown>
    </div>
  </div>

  <ng-content select=".confirmation__before-actions"></ng-content>
  <div class="confirmation__actions" *ngIf="nextActions?.length">
    <ng-container *ngIf="nextActions?.length === 1 || nextActions[1]?.type === ButtonType.URL; else multiple_actions">
      <ng-container *ngFor="let nAction of nextActions">
        <div class="confirmation__actions--single" *ngIf="nAction.type !== ButtonType.URL">
          <button
            *ngIf="nAction.type === 'button' || nAction.type === ButtonType.BUTTON"
            vo-button
            vmGtmCta
            [attr.content_link]="nAction.url"
            [type]="ButtonType.BUTTON"
            (click)="onNext($event, nAction.url, nAction.uid)"
            [variant]="nAction?.buttonLevel"
            [decoration]="nAction?.buttonStyle"
            [layout]="'full-width'">
            {{ nAction.label }}
          </button>

          <button
            *ngIf="nAction.type === ButtonType.CHAT"
            vo-button
            [type]="ButtonType.CHAT"
            (click)="openChat($event)"
            [variant]="nAction?.buttonLevel"
            [layout]="'full-width'"
            [decoration]="nAction?.buttonStyle"
            [vmLiveChatV3]="chatbotId"
            [layout]="'full-width'">
            {{ nAction.label }}
          </button>

          <button
            *ngIf="nAction.type === 'a' || nAction.type === ButtonType.ROUTER_LINK"
            vo-button
            [routerLink]="nAction?.url"
            [variant]="nAction?.buttonLevel"
            [decoration]="nAction?.buttonStyle"
            (click)="onNext($event, nAction.url, nAction.uid)"
            [layout]="'full-width'">
            {{ nAction.label }}
          </button>

          <a
            *ngIf="nAction.type === ButtonType.LINK"
            vo-button
            [type]="ButtonType.LINK"
            [href]="nAction?.url"
            [layout]="'full-width'"
            [variant]="nAction?.buttonLevel"
            [decoration]="nAction?.buttonStyle"
            [layout]="'full-width'">
            {{ nAction.label }}
          </a>

          <button
            *ngIf="nAction.type === ButtonType.MODAL"
            vo-button
            [type]="ButtonType.MODAL"
            (click)="openSecondaryModal($event)"
            [variant]="nAction?.buttonLevel"
            [decoration]="getChatButtonDecoration(nextActions, nAction.label, nAction?.buttonStyle)"
            [layout]="'full-width'">
            {{ nAction.label }}
          </button>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #multiple_actions>
      <ng-container *ngFor="let nAction of nextActions; index as i">
        <div *ngIf="i < 2" class="confirmation__actions--cta">
          <button
            *ngIf="nAction.type === 'button' || nAction.type === ButtonType.BUTTON"
            vo-button
            [type]="ButtonType.BUTTON"
            (focus)="onNext($event, nAction.url, nAction.uid)"
            [vmLiveChatV3]="nAction?.chatId"
            [variant]="nAction?.buttonLevel"
            [decoration]="nAction?.buttonStyle"
            [layout]="'full-width'">
            {{ nAction.label }}
          </button>

          <button
            *ngIf="nAction.type === ButtonType.COUNTDOWNCTA"
            vo-button
            [type]="ButtonType.COUNTDOWNCTA"
            (focus)="onNext($event, nAction.url, nAction.uid)"
            [variant]="nAction?.buttonLevel"
            [decoration]="nAction?.buttonStyle"
            [layout]="'full-width'">
            {{ nAction.label }}
          </button>

          <button
            *ngIf="nAction.type === ButtonType.CHAT"
            vo-button
            [type]="ButtonType.CHAT"
            (click)="openChat($event)"
            [variant]="nAction?.buttonLevel"
            [layout]="'full-width'"
            [decoration]="nAction?.buttonStyle"
            [vmLiveChatV3]="chatbotId">
            {{ nAction.label }}
          </button>

          <button
            *ngIf="nAction.type === 'a' || nAction.type === ButtonType.ROUTER_LINK"
            vo-button
            [type]="nAction?.type || ButtonType.ROUTER_LINK"
            [variant]="nAction?.buttonLevel"
            [decoration]="nAction?.buttonStyle"
            [layout]="'full-width'"
            (click)="onRoute($event, nAction.url)">
            {{ nAction.label }}
          </button>

          <button
            *ngIf="nAction.type === ButtonType.LINK"
            vo-button
            [type]="ButtonType.LINK"
            href="nAction?.url"
            [variant]="nAction?.buttonLevel"
            [decoration]="nAction?.buttonStyle"
            [layout]="'full-width'"
            (click)="onNext($event, nAction.url, nAction.uid)">
            {{ nAction.label }}
          </button>

          <div *ngIf="secondaryModalCopy && nAction.type === ButtonType.MODAL">
            <vo-vm-theme-provider>
              <button
                vo-button
                [type]="ButtonType.MODAL"
                (click)="openSecondaryModal($event)"
                [variant]="nAction?.buttonLevel"
                [decoration]="nAction?.buttonStyle"
                [layout]="'full-width'"
                #secondaryModal>
                {{ nAction.label }}
              </button>
              <vo-modal
                *ngIf="isSecondaryModalOpen"
                [label]="secondaryModalLabel"
                [returnFocusTo]="secondaryModal"
                (dismiss)="closeSecondaryModal($event)">
                <markdown ngPreserveWhitespaces>
                  {{ secondaryModalCopy }}
                </markdown>
              </vo-modal>
            </vo-vm-theme-provider>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </div>

  <ng-container *ngFor="let nAction of nextActions; index as i">
    <div class="confirmation__actions--tertiary" *ngIf="nAction.type === ButtonType.URL">
      <button vo-anchor *ngIf="nAction?.url?.startsWith('http')" [type]="'standalone'" href="nAction?.url">
        {{ nAction.label }}
      </button>
      <button
        vo-anchor
        vmGtmCta
        [attr.content_link]="nAction?.url"
        *ngIf="!nAction?.url?.startsWith('http')"
        [type]="'standalone'"
        [routerLink]="nAction?.url">
        {{ nAction.label }}
      </button>
    </div>
  </ng-container>

  <div class="confirmation__actions--tertiary" *ngIf="nextActions?.length > 2">
    <button vo-anchor (click)="onNextTertiary(nextActions[2], $event)" [type]="'standalone'" href="'#'">
      {{ nextActions[2]?.label }}
    </button>
  </div>

  <div class="confirmation__extra-info" *ngIf="extraInfo">
    <markdown ngPreserveWhitespaces>
      {{ extraInfo }}
    </markdown>
  </div>
  <!-- <vo-vm-theme-provider> in order for the momentum styles to work -->
  <vo-vm-theme-provider>
    <div class="confirmation__modal" *ngIf="tertiaryModalLabel && tertiaryModalCopy">
      <a vo-anchor voAlertTextLink variant="primary" (click)="openTertiaryModal($event)" [type]="'standalone'" #link>
        {{ tertiaryModalLabel }}
      </a>

      <vo-modal
        *ngIf="isTertiaryModalOpen"
        [label]="tertiaryModalTitle ?? tertiaryModalLabel"
        (dismiss)="isTertiaryModalOpen = false"
        [returnFocusTo]="link">
        <markdown ngPreserveWhitespaces>
          {{ tertiaryModalCopy }}
        </markdown>
      </vo-modal>
      <vo-modal
        *ngIf="isSecondaryModalOpen"
        [label]="secondaryModalLabel ?? secondaryModalLabel"
        (dismiss)="isSecondaryModalOpen = false"
        [returnFocusTo]="link">
        <markdown ngPreserveWhitespaces>
          {{ secondaryModalCopy }}
        </markdown>
      </vo-modal>
    </div>
  </vo-vm-theme-provider>
  <ng-content></ng-content>
</div>
